export type MapType = '2d' | '3d';

export const DefaultMapType: MapType = '2d';
